const DAYS_1 = 1;
const DAYS_3 = 3;
const MS_PER_DAY = 24 * 60 * 60 * 1000;

export const getAppendedBooking = (booking) => {
    const isPast = isPastBooking(booking)
    const isEditable = isEditableBooking(booking)
    const isClose = isCloseToEventBooking(booking)
    const isToday = isTodayEventBooking(booking)
    return {
        ...booking,
        isPast,
        isEditable,
        isClose,
        isToday,
        editDaysBefore: DAYS_3
    }
}

export const getSortedBookingList = (bookings) => {
    const groupOf = (booking) => {
        if (booking.isToday) return 0;
        if (booking.isClose) return 1;
        return 2;
    };
    const timestampOf = (booking) => Date.parse(booking?.eventDateTime ?? '');
    return [...(bookings ?? [])].sort((a, b) => {
        const groupA = groupOf(a);
        const groupB = groupOf(b);
        if (groupA !== groupB) return groupA - groupB;
        const timeA = timestampOf(a);
        const timeB = timestampOf(b);
        if (Number.isNaN(timeA) || Number.isNaN(timeB)) return Number.isNaN(timeA) - Number.isNaN(timeB);
        if (a.isPast !== b.isPast) return a.isPast - b.isPast;
        return a.isPast ? timeB - timeA : timeA - timeB;
    });
}

function isPastBooking(booking) {
    const eventTimestamp = Date.parse(booking?.eventDateTime ?? ''); // Date.parse returns NaN if the string is invalid
    if (Number.isNaN(eventTimestamp)) {
        return false;
    }
    return Date.now() > eventTimestamp + (DAYS_1 * MS_PER_DAY);
}

function isEditableBooking(booking) {
    const eventTimestamp = Date.parse(booking?.eventDateTime ?? ''); // Date.parse returns NaN if the string is invalid
    if (Number.isNaN(eventTimestamp)) {
        return false;
    }
    return Date.now() < eventTimestamp - (DAYS_3 * MS_PER_DAY);
}

function isCloseToEventBooking(booking) {
    const eventTimestamp = Date.parse(booking?.eventDateTime ?? ''); // Date.parse returns NaN if the string is invalid
    if (Number.isNaN(eventTimestamp)) {
        return false;
    }
    return eventTimestamp - (DAYS_3 * MS_PER_DAY) < Date.now() && Date.now() < eventTimestamp;
}

function isTodayEventBooking(booking) {
    const eventTimestamp = Date.parse(booking?.eventDateTime ?? ''); // Date.parse returns NaN if the string is invalid
    if (Number.isNaN(eventTimestamp)) {
        return false;
    }
    return eventTimestamp < Date.now() && Date.now() < eventTimestamp + (DAYS_1 * MS_PER_DAY);
}